import React, { useDeferredValue, useState } from 'react';
import { Input, RadioGroup } from 'rsuite';
import Modal, { ModalProps } from 'rsuite/lib/Modal';
import { ButtonPrimary, Label, Radio } from '../../../../../components';
import { LoadingSpinerArea } from '../../../../../components/LoadingSpinner';
import { SaveFiltersState } from '../../../../../reducers/ipa/priceManager/modals/saveFilters';
import './style.scss';

export type SalvarFiltrosProps = ModalProps & {
  onChange: (value: unknown) => void;
  salvarFiltros?: () => void;
  filterName?: string;
  savedFilter: Pick<SaveFiltersState, 'data' | 'name'>;
};

const OPTIONS = [
  {
    id: 1,
    value: 'PUT',
    label: 'Substituir filtro salvo',
  },
  {
    id: 2,
    value: 'POST',
    label: 'Salvar como novo filtro',
  },
];

export const SalvarFiltrosModal = ({ className = '', savedFilter: { data, name }, onChange, actions, onHide, ...props }: SalvarFiltrosProps) => {
  const [selectedOption, setSelectedOption] = useState<null | 'PUT' | 'POST'>(null);

  const deferredName = useDeferredValue(name);

  const hasValue = !!data;

  const isDisabled = (name.length === 0 || (hasValue && !selectedOption)) ?? false;

  const handleSubmit = () => {
    if (!data) {
      actions.POST();
      return;
    }

    if (selectedOption) actions[selectedOption]?.();
  };

  return (
    <Modal className={['info-modal', 'modal-salvar-filtros', className].join(' ')} onHide={onHide} {...props}>
      <form onSubmit={e => e.preventDefault()}>
        <Modal.Header>
          <Modal.Title className="font-size-200-semibold">Salvar filtro</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!!hasValue && (
            <RadioGroup onChange={setSelectedOption}>
              {OPTIONS.map(({ label, ...rest }) => (
                <Radio {...rest}>{label}</Radio>
              ))}
            </RadioGroup>
          )}
          <div className="modal-salvar-filtros__filter-name-container">
            <Label htmlFor="filter-name" className="font-size-100-regular">
              Nome do filtro
            </Label>
            <Input id="filter-name" onChange={onChange} value={deferredName ?? ''} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <ButtonPrimary
            skin="blue"
            theme="ghost"
            type="button"
            onClick={e => {
              onHide?.(e);
            }}
          >
            FECHAR
          </ButtonPrimary>
          <ButtonPrimary skin="blue" theme="filled" onClick={handleSubmit} type="submit" disabled={isDisabled}>
            SALVAR
          </ButtonPrimary>
        </Modal.Footer>
      </form>
      <LoadingSpinerArea size="sm" area="saved-filter" />
    </Modal>
  );
};
